import React, { Component, Fragment } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
//MUI stuff
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    ...theme.classes,
    commentImage: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginTop: '15px'
    },
    commentData: {
        marginTop: '15px',
        marginBottom: '15px'
    }
})

class Comments extends Component {
    render() {
        const { comments, classes } = this.props;
        return (
            <Grid container>
                {comments.map((comment, index) => {
                    const { content, created, userImage, userName } = comment;
                    return (
                        <Fragment key={created + userName}>
                            <Grid item sm={12}>
                                <Grid container>
                                    <Grid item sm={2}>
                                        <img src={userImage} alt="user" className={classes.commentImage} />
                                    </Grid>
                                    <Grid item sm={9}>
                                        <div className={classes.commentData}>
                                            <Typography
                                                component={Link}
                                                variant="h5"
                                                to={`/user/${userName}`}
                                                color="primary">
                                                {userName}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary">
                                                {dayjs(created).format('h:mm a, MMMM DD YYYY')}
                                            </Typography>
                                            <hr className={classes.invisibleSeparator} />
                                            <Typography
                                                variant="body1">
                                                {content}
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {index !== comments.length - 1 && (<hr className={classes.visibleSeparator} />)}
                        </Fragment>
                    )
                })}
            </Grid>
        )
    }
}

Comments.propTypes = { comments: PropTypes.array.isRequired };

export default withStyles(styles)(Comments);



// WEBPACK FOOTER //
// ./src/components/Post/Comments.js